import { Modal } from "antd";
import { Context } from "../index";
import { useHistory } from "react-router-dom";
import { useContext } from "react";

type Props = {
  open: boolean;
};

export const ModalRedirect = ({ open }: Props) => {
  const history = useHistory();
  const { modalStore } = useContext(Context);

  const handleOk = () => {
    history.push("/login");
    modalStore.showRedirectModal(false);
  };
  const handleCancel = () => {
    modalStore.showRedirectModal(false);
  };
  return (
    <Modal
      open={open}
      title="Attention"
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <p>To send an email, you need to complete a quick authorization</p>
    </Modal>
  );
};
